// Lista de productos con su cantidad mínima obligatoria según SKU
const minQtyBySku = [
  { sku: 'AFT00029', minQty: 100 },
  { sku: 'AFT00003', minQty: 100 },
  { sku: 'AFT00002', minQty: 100 },
  { sku: 'AFT00018', minQty: 100 },
  { sku: 'AFT00030', minQty: 100 },
  { sku: 'AFT00001', minQty: 100 },
  { sku: 'AFT00017', minQty: 100 },
  { sku: 'AFT00009', minQty: 100 },
  { sku: 'AFT00004', minQty: 100 },
  { sku: 'AFT00006', minQty: 100 },
  { sku: 'AFT00012', minQty: 100 },
  { sku: 'AFT00028', minQty: 100 },
  { sku: 'AFT00014', minQty: 100 },
  { sku: 'AFT00027', minQty: 100 },
  { sku: 'AFT00015', minQty: 100 },
  { sku: 'AFT00005', minQty: 100 },
  { sku: 'AFT00022', minQty: 100 },
  { sku: 'AFT00016', minQty: 100 },
  { sku: 'AFT00031', minQty: 100 },
  { sku: 'AFT00021', minQty: 100 },
  { sku: 'AFT00010', minQty: 100 },
  { sku: 'AFT00025', minQty: 100 },
  { sku: 'AFT00020', minQty: 100 },
  { sku: 'AFT00007', minQty: 100 },
  { sku: 'AFT00023', minQty: 100 },
  { sku: 'AFT00026', minQty: 100 },
  { sku: 'AFT00011', minQty: 100 },
  { sku: 'AFT00024', minQty: 100 },
  { sku: 'AFT00008', minQty: 100 },
  { sku: 'AFT00019', minQty: 100 },
  { sku: 'AFR00054', minQty: 50 },
  { sku: 'AFR00055', minQty: 50 }
];

// Función principal que aplica las reglas de cantidad mínima dentro del drawer
function aplicarMinimosDrawer() {
  const drawerForm = document.querySelector('#CartDrawer-Form'); // Formulario dentro del drawer
  const inputs = document.querySelectorAll('#CartDrawer input[name="updates[]"]'); // Inputs de cantidad

  // Recorre cada input de cantidad del carrito en el drawer
  inputs.forEach(input => {
    const sku = input.dataset.sku; // Extrae el SKU desde data-sku
    if (!sku) return;

    const rule = minQtyBySku.find(item => item.sku === sku); // Busca si hay regla para ese SKU
    if (!rule) return;

    // Función que corrige automáticamente si la cantidad es menor al mínimo
    const enforceMinQty = () => {
      const qty = parseInt(input.value);
      if (isNaN(qty) || qty < rule.minQty) {
        input.value = rule.minQty;
      }
    };

    // Función que también corrige, pensada para validaciones más estrictas
    const validateQty = () => {
      const qty = parseInt(input.value);
      if (isNaN(qty) || qty < rule.minQty) {
        input.value = rule.minQty;
        //alert(`Este producto requiere un mínimo de ${rule.minQty} unidades.`);
      }
    };

    enforceMinQty(); // Ejecuta validación al cargar

    input.addEventListener('input', enforceMinQty); // Valida automáticamente al escribir
    input.addEventListener('blur', validateQty); // Valida cuando se pierde el foco
    input.addEventListener('change', validateQty); // Valida al cambiar manualmente la cantidad

    // Observa si el input es modificado por otros scripts o DOM
    const observer = new MutationObserver(enforceMinQty);
    observer.observe(input, { attributes: true });
  });

  // Antes de enviar el formulario, valida que todos cumplan su mínimo
  if (drawerForm) {
    drawerForm.addEventListener('submit', function (e) {
      let bloqueado = false; // Para saber si hay cantidades inválidas

      // Recorre cada producto del drawer
      document.querySelectorAll('#CartDrawer input[name="updates[]"]').forEach(input => {
        const sku = input.dataset.sku; // Obtiene el SKU desde data-sku
        const rule = minQtyBySku.find(item => item.sku === sku); // Busca la regla de cantidad mínima por SKU

        // Si existe una regla y la cantidad es inválida o menor al mínimo
        if (rule) {
          const value = parseInt(input.value);
          if (isNaN(value) || value < rule.minQty) {
            input.value = rule.minQty; // Corrige la cantidad
            bloqueado = true; // Marca que no se debe enviar el formulario
          }
        }
      });

      // Si al menos uno no cumple, cancela el envío
      if (bloqueado) {
        e.preventDefault(); // Previene que se envíe el formulario
        //alert('Algunos productos tienen una cantidad inferior al mínimo permitido (100 unidades).');
      }
    }, { once: true }); // evita múltiples binds, se ejecuta solo una vez para evitar múltiples bindings( que se duplique la validación en futuros eventos)
  }
}

// Ejecutar al abrir o cargar el drawer o al cargar web/página
document.addEventListener('DOMContentLoaded', () => {
  aplicarMinimosDrawer(); // Aplica reglas inmediatamente

  // Observa si hay cambios dentro del drawer (por ejemplo, se agrega o actualiza un producto)
  const drawerContainer = document.querySelector('#CartDrawer');
  if (drawerContainer) {
    const observer = new MutationObserver(() => {
      aplicarMinimosDrawer(); // Reaplica las validaciones
    });
    observer.observe(drawerContainer, { 
      childList: true, // Observa si se agregan o eliminan nodos hijos directos
      subtree: true // También observa cambios dentro de los descendientes (nodos anidados)
    });
  }
});